/*====== Define import  ======*/
/*------ React ------*/
import React from 'react';
/* ------ Compornent Js /Jsx------ */
import ReactDOM from 'react-dom/client';
// import {BrowserRouter} from "react-router-dom";
import './index.css';
import App from 'App';
import { prepareAmplify } from '03CommonApiParts/prepareAmplify';
import { ProvideAuth } from '03CommonApiParts/use-auth';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from '03CommonApiParts/authConfig';

/*====== Styles  ======*/
/*------ Styled Components ------*/

/*====== global variables ======*/
/*====== global functions ======*/

/*==================*/
/*=====  Main  =====*/
/*==================*/
const root = ReactDOM.createRoot(document.getElementById('root'));
const msalInstance = new PublicClientApplication(msalConfig);

/*------ Amplify SDK利用のための準備化 ------*/
prepareAmplify();

/*--------------------------*/ 
/*------ Start Render ------*/ 
/*--------------------------*/ 
root.render(
<>
	<React.StrictMode>
		<ProvideAuth>
			<MsalProvider instance={msalInstance}>
				<App />
			</MsalProvider>
		</ProvideAuth>
    </React.StrictMode>
</>
);
reportWebVitals();
